var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThemeBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M11.5 0a11.5 11.5 0 1 0 0 23 11.5 11.5 0 0 0 0-23m0 21.2c-2.7 0-5-1.1-6.8-2.9L18.3 4.7a9.6 9.6 0 0 1-6.8 16.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThemeBw);
export default ForwardRef;